module.exports = __webpack_public_path__ + "img/87ne.cea7cdce.svg";